import axiosInstance from "./axiosInstance"; // Adjust the path if needed
import API_ENDPOINTS from "../config/apiEndpoints";

export const GetBrandsListETA = async () => {
  try {
    const response = await axiosInstance.get(
      API_ENDPOINTS.BRAND.GET_BRANDS_LIST
    );
    console.log("GetBrandsList response:", response.data); // Log API response data
    return response.data; // Assuming API returns { result: [...] }
  } catch (error) {
    console.error("GetBrandsList error:", error);
    throw error;
  }
};

export const UpsertBrandETA = async (payload) => {
  try {
    const response = await axiosInstance.post(
      API_ENDPOINTS.BRAND.UPSERT_BRAND_ETA,
      payload
    );
    console.log("UpsertBrandETA response:", response.data); // Log API response data
    return response.data; // Assuming { isSuccess: true, message: "" }
  } catch (error) {
    console.error("UpsertBrandETA error:", error);
    throw error;
  }
};
